import {
  Monitor,
  Clock,
  CalendarRange,
  Users,
  Video,
  Lock,
} from "lucide-react";

const details = [
  {
    icon: Users,
    label: "Target",
    value: "CLAT 2027 / 2028 Aspirants",
  },
  {
    icon: Monitor,
    label: "Mode",
    value: "Online (Live + Recorded Access)",
  },
  {
    icon: CalendarRange,
    label: "Duration",
    value: "6-10 Months Structured Program",
  },
  {
    icon: Video,
    label: "Sessions",
    value: "Weekly Live Sessions",
  },
  {
    icon: Clock,
    label: "Mock Tests",
    value: "Weekly Mock Tests",
  },
  {
    icon: Lock,
    label: "Seats",
    value: "Limited (Max 30 per batch)",
  },
];

export default function BatchSection() {
  return (
    <section
      id="batch"
      data-testid="batch-section"
      className="py-20 md:py-32 bg-orange-50/40"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-12 lg:px-24">
        <div className="max-w-2xl">
          <span className="text-sm font-semibold tracking-wider uppercase text-orange-600 font-body">
            Program Details
          </span>
          <h2
            data-testid="batch-title"
            className="font-heading text-3xl md:text-4xl lg:text-5xl font-semibold text-zinc-900 tracking-tight leading-tight mt-4"
          >
            Upcoming Batch Details
          </h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5 mt-14">
          {details.map((item, idx) => (
            <div
              key={idx}
              data-testid={`batch-detail-${idx}`}
              className="flex items-start gap-4 bg-white p-6 rounded-2xl border border-zinc-100"
            >
              <div className="flex-shrink-0 w-10 h-10 rounded-xl bg-orange-50 flex items-center justify-center">
                <item.icon
                  size={18}
                  strokeWidth={1.5}
                  className="text-orange-600"
                />
              </div>
              <div>
                <span className="font-body text-xs font-semibold uppercase tracking-wider text-orange-600/70">
                  {item.label}
                </span>
                <p className="font-body text-base text-zinc-800 font-medium mt-1">
                  {item.value}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
